module.exports = __webpack_public_path__ + "static/media/balance-scale-left.5c076ef2.svg";